<template>
  <span v-show="isVisible()">
      <slot></slot>
  </span>
</template>

<script>
import RouteHelper from "../helpers/route.helper";

export default {
  name: "accessible",
  props: ["routerName"],
  methods: {
    isVisible: function() {        
        return RouteHelper.isRouteNameAccessible(this.$auth.user(), this.routerName);
    }
  }
};
</script>
